module.exports = __webpack_public_path__ + "img/97e0c9c.png";